import { ADMIN_ROLES } from '@kinohelpdesk/shared';
import { useQuery } from '@tanstack/react-query';
import { Crown, type LucideIcon, Star, Wrench } from 'lucide-react';
import { adminsApi } from '@/api/client';
import { Layout } from '@/components/layout/Layout';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';
import { formatDateTime } from '@/lib/utils';

const ROLE_ICONS: Record<string, LucideIcon> = {
  owner: Crown,
  admin: Star,
  maintainer: Wrench,
};

export function AdminsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admins'],
    queryFn: () => adminsApi.list(),
  });

  return (
    <Layout title="Администраторы" subtitle="Управление командой">
      {isLoading ? (
        <div className="flex items-center justify-center h-64">
          <LoadingSpinner size="lg" />
        </div>
      ) : (
        <div className="cyber-card overflow-hidden">
          <table className="cyber-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Роль</th>
                <th>Каналы уведомлений</th>
                <th>Добавлен</th>
              </tr>
            </thead>
            <tbody>
              {data?.admins.map((admin) => {
                const role = ADMIN_ROLES[admin.role as keyof typeof ADMIN_ROLES];
                const RoleIcon = ROLE_ICONS[admin.role] ?? Wrench;
                let channels: string[] = [];
                try {
                  if (admin.notify_channels) {
                    channels = JSON.parse(admin.notify_channels) as string[];
                  }
                } catch {
                  channels = [];
                }

                return (
                  <tr key={admin.id}>
                    <td className="font-mono text-neon-cyan">#{admin.id}</td>
                    <td className="text-gray-200">@{admin.telegram_username}</td>
                    <td>
                      <span
                        className={`flex items-center gap-2 ${
                          admin.role === 'owner'
                            ? 'text-neon-yellow'
                            : admin.role === 'admin'
                              ? 'text-neon-magenta'
                              : 'text-neon-cyan'
                        }`}
                      >
                        <RoleIcon className="w-3.5 h-3.5" />
                        <span>{role?.label}</span>
                      </span>
                    </td>
                    <td className="text-gray-400">
                      {channels.length > 0 ? channels.join(', ') : 'Все'}
                    </td>
                    <td className="text-gray-400 text-sm">{formatDateTime(admin.created_at)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
